import React from 'react';

const If = ({ conditional, children }) =>
	React.Children.map(children, (child) =>
		React.cloneElement(child, { conditional })
	);

export default If;
